export default "__VITE_ASSET__B1AY64VI__$_?no-inline__"